import React from 'react';
import { Link } from 'react-router-dom';
import { MdLiveTv, MdOutlineQuiz } from 'react-icons/md';
import { BiChat, BiConversation } from 'react-icons/bi';

function QuickLinks() {
  return (
    <div className="row w-100" id="stat">
      <div className="col-md-12 col-12 my-2 pl-md-2 px-0" id="stat">
        <div className="bg-white pt-3 pb-2 pl-3 pr-2  chart_contain dash__shadow dash__border">
          <h6 style={{ fontWeight: 600 }}>Quick Links</h6>
          <div className="row">
            <Link to="live" className="col-md-3 col-6 pr-sm-2 pr-1 pl-sm-0 pl-1">
              <div
                className="info-box p-md-2 p-2 d-flex align-items-center justify-content-center"
                style={{ background: '#FDF3F3', gap: '10px' }}
              >
                <MdLiveTv size={30} color="#dc3545" />
                <span className="info-box-text text-muted">Live Classes</span>
              </div>
            </Link>
            <Link to="test" className="col-md-3 col-6 pr-sm-2 pr-1 pl-sm-0 pl-1">
              <div
                className="info-box p-md-2 p-2 d-flex align-items-center justify-content-center"
                style={{ background: '#F5E5FA', gap: '10px' }}
              >
                <MdOutlineQuiz size={30} color="#AE26D9" />
                <span className="info-box-text text-muted ">Quizzes</span>
              </div>
            </Link>
            <Link to="community" className="col-md-3 col-6 pr-sm-2 pr-1 pl-sm-0 pl-1">
              <div
                className="info-box p-md-2 p-2 d-flex align-items-center justify-content-center"
                style={{ background: '#E5FAEB', gap: '10px' }}
              >
                <BiConversation size={30} color="#26D958" />
                <span className="info-box-text text-muted">Community</span>
              </div>
            </Link>
            <Link to="ask-a-teacher" className="col-md-3 col-6 pr-sm-2 pr-1 pl-sm-0 pl-1">
              <div
                className="info-box p-md-2 p-2 d-flex align-items-center justify-content-center"
                style={{ background: '#FCEFCB', gap: '10px' }}
              >
                <BiChat size={30} color="#E9A319" />
                <span className="info-box-text text-muted">Ask a Teacher</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuickLinks;
